export default {"src":"/_next/static/image/src/images/Icons/email.2add127338ff7f3671925b262370b998.svg","height":12,"width":20};